export const loadImage = (src: string) => {
  return new Promise<HTMLImageElement>((resolve) => {
    const img = new Image();
    img.src = src;
    img.onload = () => resolve(img);
    img.onerror = () =>
      console.error(`Errore durante il caricamento dell'immagine: ${src}`);
  });
};
